
import { defineComponent, onMounted, reactive } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";

import AdminLegal from "@/components/1crm/legal/admin-legal/superadmin/admin-legal.vue";

export default defineComponent({
  name: "kt-widget-11",
  components: {
    AdminLegal,
  },
  props: {
    widgetClasses: String,
  },

  beforeMount() {

    store.dispatch(Actions.VERIFY_AUTH_BANK);

    setCurrentPageBreadcrumbs("Admin Legal", ["Data"]);
  },


});
